import { route } from 'quasar/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import ecclepRoutesResolver from './ecclepRoutes';
import registerRoutesResolver from './registerRoutes';
import { CurrentParish } from '../stores/currentParish'
import { useMeta, Loading } from 'quasar';
import { useUserStore } from 'src/stores/userStore'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(async function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : (process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory);

  const parish = await CurrentParish.getInstance();
  const parishDto = parish.get();
  const isRegister = parishDto.template === 'register';
  const routes = isRegister ? registerRoutesResolver() : ecclepRoutesResolver(parishDto.template);
  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  Router.beforeEach(async (to) => {
    const store = useUserStore();
    await store.loadUser();

    if (
      !isRegister &&
      (window.location.host.startsWith('admin') ||
        window.location.host.startsWith('localhost')) &&
      !store.isAuthenticated &&
      to.path !== '/login'
    ) {
      store.setLoginType('Next');
      store.setReturnUrl(to.path);

      return { path: '/login' };
    }

    Loading.show();
  });

  Router.afterEach((to) => {
    const title = to.meta.title as string ?? '';
    const finaldesc = to.meta.description as string ?? '';
    const resolvedTitle = title !== '' ? `${title} - ${parishDto.shortName}` : parishDto.shortName;
    const robotsContent = parishDto.code !== 'D' && !parishDto.temporaryUrl ? 'all' : 'noindex'
    const googlebotContent = parishDto.code !== 'D' && !parishDto.temporaryUrl ? 'all' : 'noindex'
    const url = to.path === '/' ? `https://${parishDto.code}.parafialnastrona.pl` : `https://${parishDto.code}.parafialnastrona.pl${to.path}`;
    const finalTitle = resolvedTitle.replace('Rzymskokatolicka parafia', 'Parafia');

    const metaData = {
      title: finalTitle,      
      meta: {        
        description: { name: 'description', content: finaldesc },
        robots: { name: 'robots', content: robotsContent },
        googlebot: { name: 'googlebot', content: googlebotContent },
        ogTitle: { name: 'og:title', content: finalTitle },
        ogDescription: { name: 'og:description', content: finaldesc },
        ogUrl: { name: 'og:url', content: url },
        ogSiteName: { name: 'og:site_name', content: parishDto.shortName },
      },

      link: {
        canonical: { rel: 'canonical', href: url }
      }
    }
    useMeta(metaData);

    Loading.hide();
  });

  return Router;
});
